function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdpRefugeeCamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 47.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#418fde",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.67 12.667a1.497 1.497 0 0 0-.59-1.01L30.5.337a1.65 1.65 0 0 0-2 0l-14.58 11.32a1.497 1.497 0 0 0-.59 1.01l-.77 5.7 3.1-2.4a4.643 4.643 0 0 1 5.68 0l5.66 4.4 2 1.55 2.69 2.09 1.28.99 2.92 2.27a4.413 4.413 0 0 1 1.7 2.73H48z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08 29.657L29 25.717l-.92-.72-1.08-.84-7.5-5.82a1.613 1.613 0 0 0-1-.34 1.593 1.593 0 0 0-1 .34l-5.51 4.28-9.07 7.04a1.497 1.497 0 0 0-.59 1.01L0 47.997h18v-9.71a.292.292 0 0 1 .3-.29.302.302 0 0 1 .26.15l5.44 9.85h13l-2.33-17.33a1.497 1.497 0 0 0-.59-1.01z",
    style: {
      fill: "#000000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdpRefugeeCamp);
export default __webpack_public_path__ + "static/media/idp-refugee-camp.2cf3761263ed9d741d0ca12ccf086405.svg";
export { ForwardRef as ReactComponent };